import { Reducer } from 'redux';
import { KnownAction } from './invoicesAction';
import { ApiInvoicesState } from './invoicesModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<ApiInvoicesState> = (state: ApiInvoicesState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            invoices: [],
            loading: true
        };
    }

    switch (action.type) {
        case 'SET_INVOICES':
            return Object.assign({}, state, { invoices: action.data });
        case 'SET_LOADING_INVOICES':
            return Object.assign({}, state, { loading: action.data });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/invoices/invoicesReducers.ts